import { get } from '@web3/base-utils';
import { GetPoolInfoRes, GetPoolListRes } from '@/types/pool';
import { baseApiUrl } from '@/config/api';

export const getPoolInfoV2 = (poolId: string) => {
  return get<GetPoolInfoRes>(`${baseApiUrl}/v2/pool/one`, { poolId });
};

export const getPoolInfoV3 = (poolId: string) => {
  return get<GetPoolInfoRes>(`${baseApiUrl}/v3/pool/one`, { poolId });
};

export const getPoolListV2 = () => {
  return get<GetPoolListRes>(`${baseApiUrl}/v2/pool/all`);
};

export const getPoolListV3 = () => {
  return get<GetPoolListRes>(`${baseApiUrl}/v3/pool/all`);
};
